import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=194b35f4"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports